import React from 'react';
import MuiIconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';

const IconButton = ({
  onClick,
  children,
  className,
  tooltip,
  disabled,
  style,
}) => {
  return (
    <Tooltip title={tooltip}>
      <MuiIconButton
        className={className}
        disabled={disabled}
        onClick={onClick}
        style={style}
      >
        {children}
      </MuiIconButton>
    </Tooltip>
  );
};

IconButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  className: PropTypes.string,
  tooltip: PropTypes.string,
  disabled: PropTypes.bool,
};

export default IconButton;



// WEBPACK FOOTER //
// ./src/components/common/icon-button.js